import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken2} from "../../funciones/ClienteAxios";
import axios from 'axios';

export default function Mapa() {
  const mapRef = useRef()
  const params = useParams()
  let history = useNavigate();
  const source = axios.CancelToken.source();
  const [cargando, setCargando] = useState(true)
  const [listPoligono, setListPoligono] = useState([])
  
   useEffect(()=>{
    
  //  console.log(params);
    if (params.usuario!=="" && params.usuario!==null ) {
      /* if (params.banderaId!=="" && params.banderaId!==null ) {
        getListPoligono(params.usuario,params.banderaId)
      }  */ 
        getListPoligono(params.usuario,"",params.edoId,params.municipioId)
    }
   mapRef.current =  leaflet.map('map').setView([19.3805297,-99.1821412], 13);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    /* let marker = leaflet.marker([19.55118915734468,-99.01875702149020]);    
    marker.bindPopup('This is Tutorialspoint').openPopup();
    marker.addTo(mapRef.current).on('click', mostrar);  */
    
/*     const polygon = leaflet.polygon([[[19.55098800000000,-99.02011000000000],                
        [19.55098800000000,-99.02011000000000]],]], { fillOpacity: 0.5, fillColor: '#9a8fcd' });
    polygon.addTo(mapRef.current); */
    
    mapRef.current.addEventListener("click",(e)=>{
      console.log(e);        
    })

    return () => {
      source.cancel();
    }

  },[]) 

  function getListPoligono(usuId,auxToken,edoId,munId) {
    const data = qs.stringify({
      usuario: usuId,  
      estado:edoId,
      municipio:munId,
      ip:"127.0.0.0",         
      idDispositivo: "451224452121"
    });

    const url = "lugar/colonia/gps/poligono";

    function respuesta(response) {
      if (response[0].Id !== -1) {
        setListPoligono(response)     
        let arrPoligono=[]
         let greenIcon = new leaflet.Icon({
          iconUrl: '/marker-icon-2x-green.png',
          shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });        
        
        
        mapRef.current.setView([response[0].gps[0].Lat,response[0].gps[0].Lon]);
        response.forEach((poligono)=>{
          let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })  
          }
          
          arrPoligono.push(arrPath)
          const cadena=`${poligono.Nom}`   
          let marker = leaflet.marker([poligono.LAT,poligono.LON],{icon:greenIcon},{alt: cadena});                     
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar); 
        })   
        
        const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: '#9a8fcd' });
        polygon.addTo(mapRef.current);
      }
    }

    llamaApiCargaToken2(data, url, respuesta, ErrorGeneral, setCargando, history,source,auxToken);
  }
  
  
  const mostrar=(e)=>{
    console.log(e);
    
  }
 
  return (
  <div >
    {/* <h1>prueba</h1> */}
    <div id="map" ref={mapRef} style={{height:"100vh"}}></div>
  </div>
  );
}